import MultipleBadge from './MultipleBadge'
import OverlayView from './OverlayView'

interface CustomMarkerProps {
  map?: google.maps.Map
  onClick: (map: google.maps.Map) => void
  location: {
    lat: number
    lng: number
  }
  count: number
}

const Multiple = ({ map, onClick, count, location }: CustomMarkerProps) => {
  if (map) {
    return (
      <OverlayView
        position={{
          lat: location.lat,
          lng: location.lng,
        }}
        map={map}
      >
        <MultipleBadge onClick={onClick} count={count} />
      </OverlayView>
    )
  }

  return null
}

export default Multiple
